import { Fragment, useContext } from "react";
import { Navigate, Route, Routes, useRoutes } from "react-router-dom";
import { AppContext } from "./context/App";

import DashboardLayout from "../layouts/dashboard";
import AuthLayout from "../layouts/auth";

import LoginForm from "../components/Login";
import ProfilePage from "../components/Profile";
import SupportTickets from "../components/SupportTickets";
import AdminsManagement from "../components/AdminsManagement";
import RolesManagement from "../components/RolesManagement";
import TicketCategoriesManagement from "../components/TicketCategoriesManagement";
import CustomersManagement from "../components/CustomersManagement";
import ClaimerManagement from "../components/ClaimerManagement";
import SponsorManagement from "../components/SponsorManagement";
import VestingManagement from "../components/VestingManagement";
import SmartContractManagement from "../components/SmartContractManagement";
import EditSmartContract from "../components/SmartContractManagement/EditSmartContract";
import SmartContractsLayout from "../layouts/smart-contracts";
import { FileStructureContextProvider } from "./context/FileStructure";
import ResetPasswordForm from "../components/ResetPassword";
import NotFound from "../components/NotFound";

export default function AppRouter() {
  const { user } = useContext(AppContext);

  return (
    <Routes>
      <Route path="*" element={<Navigate to="/404" />}></Route>
      <Route
        path="/"
        element={user ? <DashboardLayout /> : <Navigate to="/login" replace />}
      >
        <Route path="404" element={<NotFound />} />
      </Route>

      <Route
        path="/"
        element={
          user ? (
            <Navigate to="/dashboard/claimer-management" />
          ) : (
            <Navigate to="/login" replace />
          )
        }
      />
      <Route
        path="login"
        element={
          user ? (
            <Navigate to="/" replace />
          ) : (
            <AuthLayout
              title="Admin Gate Sign In"
              description="Welcome back! Please signin to continue.."
            >
              <LoginForm />
            </AuthLayout>
          )
        }
      />
      <Route
        path="password/reset"
        element={
          user ? (
            <Navigate to="/" replace />
          ) : (
            <AuthLayout title="Admin Gate | Auth" description="Reset Password">
              <ResetPasswordForm />
            </AuthLayout>
          )
        }
      />
      <Route
        path="/dashboard"
        element={user ? <DashboardLayout /> : <Navigate to="/login" replace />}
      >
        <Route path="*" element={<Navigate to="/404" />} />

        <Route path="users-management" element={<AdminsManagement />} />
        <Route path="roles-management" element={<RolesManagement />} />
        <Route
          path="ticket-categories"
          element={<TicketCategoriesManagement />}
        />

        <Route element={<SmartContractsLayout />}>
          <Route
            path="customers-management"
            element={<CustomersManagement />}
          />
          <Route path="vesting-management" element={<VestingManagement />} />
          <Route path="claimer-management" element={<ClaimerManagement />} />
          <Route path="sponsor-management" element={<SponsorManagement />} />
        </Route>

        <Route element={<FileStructureContextProvider />}>
          <Route
            path="smart-contract-management"
            element={<SmartContractManagement />}
          />
          <Route
            path="smart-contract-management/edit/:uuid"
            element={<EditSmartContract />}
          />
        </Route>

        <Route path="profile" element={<ProfilePage />} />
        <Route path="support-tickets" element={<SupportTickets />} />
      </Route>
    </Routes>
  );
}
